import React from 'react';
import { IconProps } from './IconProps';

interface MessageIconProps extends IconProps {
  isActive?: boolean;
}

const MessageIcon: React.FC<MessageIconProps> = ({ isActive = false }) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9H6.01M10 9H10.01M14 9H14.01M19 9C19 13.418 14.97 17 10 17C8.52877 17.0038 7.0752 16.6796 5.745 16.051L1 17L2.395 13.28C1.512 12.042 1 10.574 1 9C1 4.582 5.03 1 10 1C14.97 1 19 4.582 19 9Z"
        stroke={isActive ? '#2C1662' : '#828088'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MessageIcon;
